<template>
  <div class="v2-event-detail v2-container v2-section">
    <div class="v2-event-detail__back">
      <BaseButton
        variant="ghost"
        size="sm"
        to="/member-v2/events"
        icon="mdi-arrow-left"
      >
        Volver al catálogo
      </BaseButton>
    </div>

    <div v-if="!resolvedEventId" class="v2-event-detail__error">
      <EmptyState
        title="Evento no disponible"
        description="No se encontró el identificador del evento. Vuelve al catálogo e intenta de nuevo."
        icon="mdi-alert-circle-outline"
      >
        <BaseButton variant="primary" to="/member-v2/events">Ir al catálogo</BaseButton>
      </EmptyState>
    </div>

    <div v-else class="v2-event-detail__microsite">
      <Microsite />
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/memberDashboardV2/ui/BaseButton.vue";
import EmptyState from "@/components/memberDashboardV2/ui/EmptyState.vue";
import Microsite from "@/views/landing/Microsite.vue";

export default {
  name: "MemberDashboardV2EventDetail",
  components: { BaseButton, EmptyState, Microsite },
  props: {
    eventId: { type: [String, Number], default: null },
  },
  computed: {
    resolvedEventId() {
      if (this.eventId) return this.eventId;
      const param = this.$route && this.$route.params && this.$route.params.eventId;
      return param || null;
    },
  },
};
</script>

<style scoped>
.v2-event-detail {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.v2-event-detail__back {
  display: flex;
  align-items: center;
}

.v2-event-detail__error {
  padding: var(--space-6);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}

.v2-event-detail__microsite {
  min-width: 0;
}
</style>
